import React from 'react'
import styles from './ProtocolInfographic.module.css'

export default function HeroStat({ label, value, accent }) {
  const safeLabel = label || ''
  const safeValue = value !== undefined && value !== null ? value : '--'
  const safeAccent = accent || '#111827'

  return (
    <div className={styles.heroStatWrapper}>
      <div className={styles.heroStatLabel}>{safeLabel}</div>
      <div className={styles.heroStatValue} style={{ color: safeAccent }}>
        {safeValue}
      </div>
    </div>
  )
}
